import {Pipe, PipeTransform} from '@angular/core';
import {Column, DisplayField, TermSearchResult} from '@twpub/core/models';

@Pipe({
  standalone: true,
  name: 'getDisplayField',
  pure: true // make pipe pure and ensure component replaces map instances when updated
})
export class GetDisplayFieldPipe implements PipeTransform {
  private static readonly EMPTY_DF: DisplayField = Object.freeze({
    oid: '',
    label: '',
    value: '',
    jsonField: undefined as any
  });

  transform(res: TermSearchResult, col: Column): DisplayField {
    const resAny = res as any;
    if (!resAny.displayFieldsMap) {
      return GetDisplayFieldPipe.EMPTY_DF;
    }

    // Determine the correct field key to use
    let fieldKey = col.field;

    // If column has dicts restriction and this result's dictionary is in that list,
    // find the field by label and use its jsonField
    if (col.dicts?.length && col.dicts.includes(res.term.dictionaryId)) {
      const fieldByLabel = col.label
        ? res.displayFields?.find(df => df.label === col.label)
        : null;
      if (fieldByLabel?.jsonField) {
        fieldKey = fieldByLabel.jsonField;
      }
    }

    // Use composite key: field:concept for concept-level, field:term:lang for term-level columns
    const level = col.lang?.length ? 'term' : 'concept';
    let compositeKey = fieldKey + ':' + level;
    if (col.lang?.length) {
      compositeKey += ':' + col.lang;
    }

    return resAny.displayFieldsMap.get(compositeKey) || GetDisplayFieldPipe.EMPTY_DF;
  }
}
